import {Fragment, useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {notification} from "antd";
import ActionBar from "~/layout/ActionBar";
import {
	Loading, Icon, Button, Modal
} from "~/components";
import {
	apiError,
	handleRequest,
	strToTime,
	numberFormat
} from "~/utils";
import {
	pendingReceiptActions,
	pendingReceiptErrorSelector,
	pendingReceiptFilterSelector,
	pendingReceiptItemsSelector,
	pendingReceiptLoadingSelector,
	pendingReceiptPaginationSelector,
	pendingReceiptSummarySelector
} from "../pendingReceiptSlice";
import {
	PendingReceiptTable,
	PendingReceiptFormAddEdit,
	PendingReceiptFormResolve,
	PendingReceiptSearchBar
} from "../components";
import {
	pendingReceiptApi
} from "~/api";

function PendingReceipt() {

	const dispatch   = useDispatch();

	const items      = useSelector(pendingReceiptItemsSelector);

	const loading    = useSelector(pendingReceiptLoadingSelector);

	const error      = useSelector(pendingReceiptErrorSelector);

	const pagination = useSelector(pendingReceiptPaginationSelector);

	const filter     = useSelector(pendingReceiptFilterSelector);

	const summary    = useSelector(pendingReceiptSummarySelector);

	const [itemEdit, setItemEdit] = useState({});

	const [openModal, setOpenModal] = useState({
		addEdit: false,
		resolve: false,
		delete: false,
	});

	const handleModalOpen = (modal) => {
		openModal[modal] = true;
		setOpenModal({...openModal})
	}

	const handleModalClose = (modal) => {
		openModal[modal] = false;
		setOpenModal({...openModal});
	}

	useEffect(() => {
		dispatch(pendingReceiptActions.fetchData({
			...filter,
		}));
	}, [filter]);

	if (error) {
		notification.error({message: 'Lỗi', description: error});
	}

	const handleSaveItem = async (data, isEdit) => {
		let messageAction = 'Thêm mới';
		if(isEdit) {
			if (!itemEdit?.id) {
				notification.error({message: 'Lỗi', description: 'Không có thông tin khoản thu để cập nhật'});
				return;
			}
			data.id = itemEdit.id;
			messageAction = 'Cập nhật';
		}
		data.time = strToTime(data.time);
		let [error, response] = (isEdit) ? await handleRequest(pendingReceiptApi.update(data)) : await handleRequest(pendingReceiptApi.add(data));
		let message = apiError(`${messageAction} khoản thu thất bại`, error, response);
		if(!message) {
			notification.success({message: 'Thành công', description: `${messageAction} khoản thu thành công`});
			if(!isEdit) {
				dispatch(pendingReceiptActions.add(response.data));
			}
			else {
				setItemEdit(response.data);
				dispatch(pendingReceiptActions.update(response.data));
			}
			handleModalClose('addEdit');
			dispatch(pendingReceiptActions.fetchData({...filter}));
		}
	}

	const handleResolve = async (data) => {
		if (!itemEdit?.id) {
			notification.error({message: 'Lỗi', description: 'Không có thông tin khoản thu'});
			return;
		}
		let [error, response] = await handleRequest(pendingReceiptApi.status(data));
		let message = apiError(`Cập nhật trạng thái thất bại`, error, response);
		if(!message) {
			notification.success({message: 'Thành công', description: `Cập nhật trạng thái thành công`});
			dispatch(pendingReceiptActions.update(response.data));
			handleModalClose('resolve');
			dispatch(pendingReceiptActions.fetchData({...filter}));
		}
	}

	const handleDelete = async () => {
		if (!itemEdit?.id) {
			notification.error({message: 'Lỗi', description: 'Không có thông tin khoản thu để xóa'});
			return;
		}
		let [error, response] = await handleRequest(pendingReceiptApi.delete(itemEdit.id));
		let message = apiError(`Xóa khoản thu thất bại`, error, response);
		if(!message) {
			notification.success({message: 'Thành công', description: `Xóa khoản thu thành công`});
			dispatch(pendingReceiptActions.delete(itemEdit.id));
			handleModalClose('delete');
			dispatch(pendingReceiptActions.fetchData({...filter}));
		}
	}

	const handlePaginationChange = (page) => {
		dispatch(pendingReceiptActions.setFilter({...filter, page}));
	}

	const handleFilterChange = (key, value) => {
		const newFilter = {
			...filter,
			[key]: value,
			page: 1
		};
		dispatch(pendingReceiptActions.setFilter(newFilter));
	};

	return (
		<Fragment>
			<ActionBar title={'Thu chờ xác định'}>
				<Button outline leftIcon={Icon.plusCircle} onClick={() => {setItemEdit({}); handleModalOpen('addEdit')}}>Thêm mới</Button>
				<Button outline small onClick={() => dispatch(pendingReceiptActions.fetchData({...filter}))} style={{fontSize:'20px'}}>{Icon.reload}</Button>
			</ActionBar>
			<div className="container">
				<div className="content">
					{loading && <Loading/>}
					<div className="d-flex gap" style={{padding: '10px 0'}}>
						<div className="badge-total" style={{padding: '8px 16px', background: '#fffbe6', border: '1px solid #ffe58f', borderRadius: '6px'}}>
							Tổng tiền đang chờ xác định: <b style={{color: '#d48806'}}>{numberFormat(summary?.pending || 0)}đ</b>
						</div>
						<div className="badge-total" style={{padding: '8px 16px', background: '#f6ffed', border: '1px solid #b7eb8f', borderRadius: '6px'}}>
							Tổng theo bộ lọc: <b style={{color: '#389e0d'}}>{numberFormat(summary?.total || 0)}đ</b>
						</div>
					</div>
					{<PendingReceiptSearchBar filter={filter} onChange={handleFilterChange} />}
					{items && <PendingReceiptTable
						items={items}
						pagination={pagination}
						onPaginationChange={handlePaginationChange}
						setItemEdit={setItemEdit}
						openModal={handleModalOpen}
					/>}
				</div>
				{
					<Modal title="Khoản thu chờ xác định" visible={openModal.addEdit} onCancel={() => {handleModalClose('addEdit')}}>
						<PendingReceiptFormAddEdit item={itemEdit} onHandleSubmit={handleSaveItem} />
					</Modal>
				}
				{
					(itemEdit?.id) && <Modal title="Xác định nguồn" visible={openModal.resolve} onCancel={() => {handleModalClose('resolve')}}>
						<PendingReceiptFormResolve item={itemEdit} onHandleResolve={handleResolve} />
					</Modal>
				}
				{
					(itemEdit?.id) && <Modal title="Xóa khoản thu" visible={openModal.delete} onCancel={() => {handleModalClose('delete')}}>
						<p>Bạn muốn xóa khoản thu <b>TCD{itemEdit?.id}</b>?</p>
						<br />
						<div className="d-flex justify-content-end gap pd-1 modal-bottom">
							<Button white leftIcon={Icon.close} onClick={() => {handleModalClose('delete')}}> Đóng </Button>
							<Button primary leftIcon={Icon.delete} onClick={handleDelete}> Xóa </Button>
						</div>
					</Modal>
				}
			</div>
		</Fragment>
	)
}

export default PendingReceipt;
